import { render, staticRenderFns } from "./ToolsBigBtn.vue?vue&type=template&id=bcd342c8&scoped=true"
import script from "./ToolsBigBtn.vue?vue&type=script&lang=js"
export * from "./ToolsBigBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd342c8",
  null
  
)

export default component.exports